module.exports = __webpack_public_path__ + "static/hero-top-2-e691ef22717e52a0cab950f80597cf81.png";